export default __webpack_public_path__ + "static/media/shape3.2555ee1f.webp";